module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-700italic.woff2?da0e717829e033a69dec97f1e155ae42";